import React, { useEffect, useState } from 'react';
import { list } from '../../services/exportMetRateData';
import MetRateDownloadView from '../../components/MetRateDownloadView/MetRateDownloadView';

import './DownloadPage.css';

export default function DownloadPage(props) {
  const { jwt } = props || {};
  const [dataIndexes, setDataIndexes] = useState({});

  useEffect(() => {
    let isMounted = true;
    list()
      .then((response) => {
        if (isMounted) setDataIndexes(response);
      })
      .catch((errorObject) => {
        if (isMounted) setDataIndexes({ error: errorObject.message });
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="download-page">
      <div className="download-page-title">Download</div>
      <div className="download-options">
        <div className="download-NBL">
          {dataIndexes.error || Object.keys(dataIndexes).length === 0 ? (
            <span>{dataIndexes.error || 'Loading...'}</span>
          ) : (
            <MetRateDownloadView dataIndexes={dataIndexes} jwt={jwt} />
          )}
        </div>
      </div>
    </div>
  );
}
